import { defineComponent } from 'vue';

import { NotificationsHostMixin } from '@/bundles/App/mixins/NotificationsHostMixin';

export const AppFormMixin = defineComponent({
  mixins: [NotificationsHostMixin],
  methods: {
    showFormValidationErrorNotification (message?: string) {
      this.addNotification({
        status: 0,
        title: 'Error',
        message: message || 'Please fill in all required fields before submitting the form.',
      });
    }
  }
})
